<template>
  <div id="app">
    <div v-if="facility=='app'" :class="facility=='app'?'content':''" >
      <!-- <Applogin/> -->
    </div>
    <div v-else>
      <Pnav/>
      <div class="height"></div>
      <router-view></router-view>
      <Pfooter  />
    </div>
  </div>
</template>

<script>
// import Applogin from "./components/pc/applogin";
import Pnav from "./components/pc/nav";
import Pfooter from "./components/pc/footer";
import { reqAutoLogin } from "./api";
export default {
  name: 'App',
  components: {
    // Applogin,
    Pnav,
    Pfooter
  },
  data () {
    return {
      facility:false  
    }
  },
  
  beforeMount(){
    this.facility = this.isMobile()
    this.autologin()
  },
  methods:{
    async autologin(){
      const response = await reqAutoLogin()
      // console.log(response);
      if (response.code) {
        this.$store.dispatch("userInformation",response.resilt)
        this.$store.dispatch("isLogin",1)
      }else{
        localStorage.removeItem('islogin')
        localStorage.removeItem('user')
        this.$store.dispatch("userInformation",'')
        this.$store.dispatch("isLogin",0)
      }
    },
    
    // launch1(){
    //   console.log(12333);
    // },
    // error1(){
    //   console.log(22222);
    // }
    
  }
}
</script>

<style>
  *{
    padding: 0;
    margin: 0;
    /* list-style: none; */
    /* text-decoration: none; */
  }
  .appcode{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    width: 300px;
  }
  .appcode h2{
    margin-bottom: 30px;
  }
  .height{
    height: 61px;/*no*/
  }
  .weui-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (min-width: 768px) and (max-width: 900px) {
    .height{
      height: 121px;/*no*/
      height: 61px;/*no*/
    }
  }



  #app{
    overflow: hidden;
    width: 100%;
  }
  .content{
    width: 100%;
    height: 100vh;
  }
  .app {
    padding: 0 10px;
    width: 100%;
    height: calc(100vh - 50px);
    overflow-y: auto;
    box-sizing: border-box;
    font-size: 12px;
  }
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    outline: none;
  }

  .more_loading{
    text-align: center;
    padding-bottom: 10px;
    width: 100%;
  }
  .m_upload{
    display: flex;
    justify-content: center;
  }
  .m_upload span{
    margin-right:5px ;
  }
  .detailsContent{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
  }
  /* @media (min-width: 768px) and (max-width: 991px) {
    .nav li>span{
      padding: 0 5px;
    }
  } */
  
</style>
